var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.$t("wp.whatsAppIntegrationAgreementTitle")))]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("wp.agreementAcceptLead")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("wp.agreementLegalP1")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("wp.agreementLegalP2")))]),
    _vm._v(" "),
    _c("p", [_vm._v(_vm._s(_vm.$t("wp.agreementLegalP3")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex justify-content-end" },
      [
        _c(
          "a-button",
          { attrs: { type: "primary" }, on: { click: _vm.agree } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("wp.readAndAgree")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }